import React from "react";
import { NavLink } from "react-router-dom";

const RolesList = ({ filmId, sceneId, characters }) => {
  return (
    <aside className="menu">
      <p className="menu-label">Characters in scene</p>
      <ul className="menu-list">
        {(characters || []).map((character, idx) => {
          return (
            <li key={idx}>
              <NavLink
                to={`/films/${filmId}/scenes/${sceneId}/characters/${character.id}/edit`}
                activeClassName="is-active"
              >
                {character.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default RolesList;
